var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'contact'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _vm.currentSweepStakes.length ? _c('section', {
    staticClass: "pt-16 sm-md:pt-32 contact--section effect--fade-slide-in"
  }, [_c('div', {
    staticClass: "section--container section--container-page"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("Giveaways")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-12 space-y-6 sm-md:space-y-4 sm-md:mt-8"
  }, _vm._l(_vm.currentSweepStakes, function (sweep) {
    return _c('li', {
      key: sweep.id
    }, [_c('a', {
      staticClass: "text-lead btn-arrow",
      attrs: {
        "href": sweep.tos_url,
        "target": "blank"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.formatTitle(sweep.title, sweep.starts_at, sweep.ends_at)) + "\n\t\t\t\t\t\t")])]);
  }), 0)])])]) : _c('section', {
    staticClass: "pt-16 sm-md:pt-32 contact--section effect--fade-slide-in"
  }, [_vm._m(0)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section--container section--container-page"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("There are no Giveaways at this time.")]), _vm._v(" "), _c('h2', [_vm._v("Please check back later.")])])]);
}];
export { render, staticRenderFns };